var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',{attrs:{"name":"feedback-page-container"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[_c('FeedbackForm',{attrs:{"feedback":_vm.models.feedback,"icons":_vm.icons,"urls":_vm.models.urls}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }